module.exports = __webpack_public_path__ + "img/accept-order.ff4142ff.png";